// covered-by: frontends/carrie/src/components/memory-citation/__tests__/MemoryCitationChip.test.tsx

import { ASK_V2_KNOWLEDGE_DATABASE_SEARCH } from "../../ask-v2/paths";
import { memorySearchTerm } from "../../routes/settings/routes/knowledge-database/memorySearch";
import { KNOWLEDGE_DATABASE_PATH } from "../../routes/settings/routes/knowledge-database/search";

/** Where "Open in Memories" goes. */
export const MEMORY_LINK_TO = KNOWLEDGE_DATABASE_PATH;

/**
 * The Memories tab, searched for the memory.
 *
 * By search and not by id: the graph's node id and the memories API's `_id` are
 * different identifiers (`memorySearch.ts`), so only the memory's own words find
 * its row. The rail's earlier "Memory" row, the chip's popover and the new rail
 * card all link through this one, so they cannot disagree about where it goes.
 */
export function memoryTabSearch(text: string) {
  const q = memorySearchTerm(text);
  return {
    ...ASK_V2_KNOWLEDGE_DATABASE_SEARCH,
    tab: "memories" as const,
    ...(q ? { q } : {}),
  };
}
